export default  { 
    Intituicao:[
    {id:1, select:"Polícia Militar"},
    {id:2, select:"Ambulância"}, 
    {id:3, select:"Bombeiro"},
    {id:4, select:"Prefeitura"},
    ]
    
 };
    
